module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGdf5b1b9c78b153b0d81f42d5b7c58ac1.df5b1b9c.png";